module.exports = __webpack_public_path__ + "img/help.19d6239f.png";